import {
  getPricingsFromCdnByAgentId,
  getLoanCalculatorsByPricings,
} from "@nemuru-eng/js-api-client/slim";
import { useContext, useState, useEffect } from "react";
import { ProcessContext } from "../../../../../../contexts/ProcessContext";

export const useLoanCalculatorsByPricings = () => {
  const {
    state: { loan },
  } = useContext(ProcessContext);

  const [isLoadingPricings, setIsLoadingPricings] = useState(true);
  const [loanCalculators, setLoanCalculators] = useState(null);

  useEffect(() => {
    const fetchPricings = async () => {
      if (!loan?.agent_id) return;

      setIsLoadingPricings(true);
      try {
        const response = await getPricingsFromCdnByAgentId({
          agentId: loan.agent_id,
        });
        const loanCalculators = getLoanCalculatorsByPricings({
          pricings: response,
          principal: {
            value: loan.loan_conditions.principal.amount,
            currency: loan.loan_conditions.principal.currency,
          },
          product: loan.loan_conditions.product,
          terms: [loan.loan_conditions.loan_calculator.term.period],
        }).map((loanCalculator) => loanCalculator.toLoanCalculatorDto());
        setLoanCalculators(loanCalculators);
      } catch (error) {
        console.error("Error fetching pricings from CDN:", error);
      } finally {
        setIsLoadingPricings(false);
      }
    };

    fetchPricings();
  }, [loan?.agent_id]);

  return {
    loanCalculators,
    isLoadingPricings,
  };
};
